import { CAPABILITY_KEYS, CapabilityKey } from './capabilityKeys';

export {
  applyCapabilityClosures,
  CAPABILITY_KEYS,
  type CapabilityKey,
} from './capabilityKeys';

export function hasCapability(
  capabilities: Record<string, boolean> | null | undefined,
  key: CapabilityKey | string
): boolean {
  return Boolean(capabilities?.[key]);
}

/** Account calendar requires hotlist + accounts. */
export function canUseAccountCalendar(
  capabilities: Record<string, boolean> | null | undefined
): boolean {
  return (
    hasCapability(capabilities, CAPABILITY_KEYS.HOTLIST) &&
    hasCapability(capabilities, CAPABILITY_KEYS.ACCOUNTS)
  );
}

export function hotlistSourceEnabled(
  capabilities: Record<string, boolean> | null | undefined,
  source: 'accounts' | 'industries' | 'assets'
): boolean {
  if (!hasCapability(capabilities, CAPABILITY_KEYS.HOTLIST)) return false;
  return hasCapability(capabilities, source);
}
